import { useFeedback, useTranslation } from "@opendash/core";
import { saveTicket } from "../..";

export const useSaveTicketProject = () => {
  const t = useTranslation();
  const { handleLoadingFeedback } = useFeedback();

  async function saveProject(projectId: string, ticketId: string) {
    await handleLoadingFeedback(
      () => saveTicket({ existingTicketId: ticketId, project: projectId }),
      t("maintenance:ticket.project.loading"),
      t("maintenance:ticket.project.success"),
      t("maintenance:ticket.project.error")
    );
  }

  return saveProject;
};
